module.exports = __webpack_public_path__ + "static/img/logo.07d1e22e.svg";